export const ALLOWED_FILE_EXTENSIONS = [
    ".pdf",
    ".xlsx",
    ".xlsm",
    ".csv",
    ".doc",
    ".docs",
    ".docx",
    ".ppt",
    ".png",
    ".jpg",
    ".jpeg",
  ];
  
  export const ALLOWED_IMAGE_EXTENSIONS = [".gif", ".png", ".jpg", ".jpeg"];
  
  export const ALLOWED_DOCUMENT_EXTENSIONS = [".doc", ".docs", ".docx"];
  
  export const ALLOWED_EXCEL_EXTENSIONS = [".xlsx", ".xlsm"];
  
  export const ALLOWED_MIME_TYPES = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "text/csv",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "image/png",
    "image/jpeg",
  ];
  
  export const ALLOWED_IMAGE_MIME_TYPES = [
    "image/gif",
    "image/png",
    "image/jpeg",
  ];